import { AbstractSerializer } from '../../../common/AbstractSerializer';
import type { BinaryReader } from '../../../common/BinaryReader';
import Header from '../../../common/Header.js';
import { initWorker } from '../../../common/WorkerUtility.js';
import type { LayerRecord, SerializerResolver } from '@visualizer/types';

export default class IntsSerializer extends AbstractSerializer<void> {
    public readonly version: string;
    private readonly fileVersion: string;

    constructor(version: string) {
        super();
        this.version = version;
        this.fileVersion = version;
    }

    public async read(reader: BinaryReader, layer: LayerRecord, sm: SerializerResolver): Promise<void> {
        const worker = await initWorker();

        worker.onmessage = (e: MessageEvent<Record<string, any>>) => {
            if (e.data.ints != null) {
                const { frameID, spID, R, ints } = e.data;
                layer.intsHandler?.addIntersections?.(frameID, spID, R, ints);
            }

            if (e.data.finished === true) {
                if (layer.intsHandler) {
                    layer.intsHandler.loadingStatus = 'loaded';
                }

                console.log('Intersections have been loaded in all the Frames and ready to use');
                worker.terminate();
            }
        };
        const headerSerializer = sm.findSerializer(this.fileVersion, Header, 'binary');
        worker.postMessage({ data: reader.getData(), kind: 'ints', serializerVersion: headerSerializer.serializerVersion }, [
            reader.getData(),
        ]);
    }
}

export function loadINTS(
    generalLoader: BinaryReader,
    sensorPointsN: number,
    postMessage: (payload: Record<string, unknown>) => void
): void {
    const frameCount = generalLoader.readUInt8();

    for (let f = 0; f < frameCount; f++) {
        generalLoader.readString();

        for (let n = 0; n < sensorPointsN; n++) {
            const ints: number[][] = [];
            const rayCount = generalLoader.readUInt16();

            for (let r = 0; r < rayCount; r++) {
                ints[r] = [];
                const intersectionCount = generalLoader.readUInt8();
                for (let i = 0; i < intersectionCount; i++) {
                    ints[r][i] = generalLoader.readFloat32();
                }
            }

            postMessage({ frameID: f, spID: n, R: rayCount, ints });
        }
    }
}
